module.exports = __webpack_public_path__ + "img/presenca.4c884cae.png";